module.exports = __webpack_public_path__ + "img/gg.d080b3f9.svg";